module.exports = __webpack_public_path__ + "img/custom-service.d25e2beb.png";